import { z } from 'zod';
import { COPACK_FILTRES } from '../domain/copacking-roles.js';
/**
 * Sources de mouvements.
 *
 * Les trois premieres composent la **comptabilite physique** (WMS) ; `GEJNM`
 * porte les mouvements **declares au portail des douanes** (filtres `CODMTR=ALCDS`).
 * Le rapprochement brut oppose la somme des trois premieres a la quatrieme.
 */
export const MOVEMENT_SOURCES = ['GERECD', 'GESUPD', 'JNL_NON_SYSTEME', 'GEJNM'];
export const movementSourceSchema = z.enum(MOVEMENT_SOURCES);
export const MOVEMENT_SOURCE_LABELS = {
    GERECD: 'Réceptions (GERECD)',
    GESUPD: 'Livraisons (GESUPD)',
    JNL_NON_SYSTEME: 'Journal des mouvements',
    GEJNM: 'Comptabilité matières (GEJNM)',
};
/** Sources composant la comptabilite physique WMS. */
export const WMS_SOURCES = ['GERECD', 'GESUPD', 'JNL_NON_SYSTEME'];
/** Source declaree a la douane. */
export const DOUANE_SOURCE = 'GEJNM';
export const reconciliationQuerySchema = z.object({
    du: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date attendue au format AAAA-MM-JJ')
        .optional(),
    au: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date attendue au format AAAA-MM-JJ')
        .optional(),
    /** Bascule article / famille d'equivalence validee. */
    maille: z.enum(['ARTICLE', 'FAMILLE']).default('ARTICLE'),
    /** Inclure les articles marques « hors perimetre de controle ». */
    inclureHorsControle: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .transform((valeur) => (typeof valeur === 'boolean' ? valeur : valeur === 'true'))
        .default(false),
    search: z.string().trim().max(120).optional(),
    /** Filtre par role de copacking (demande Leonie, 11/09/2026). */
    copack: z.enum(COPACK_FILTRES).optional(),
});
/**
 * Bandeau obligatoire de l'ecran et de l'export : le rapprochement de P2 compte
 * **tous** les mouvements, sans aucune regle de neutralisation.
 */
export const RECONCILIATION_BANNER = 'Rapprochement brut — avant application des règles de neutralisation';
/**
 * Date d'ancrage du rapprochement : l'inventaire physique de debut d'annee.
 * Aucun mouvement anterieur n'entre en base (regle 3 du CLAUDE.md).
 */
export const RECONCILIATION_ANCHOR_DATE = '2026-01-01';
/**
 * Seuil d'alignement du KPI d'entrées, en UVC. Deux quantités sont « alignées »
 * quand elles diffèrent de **strictement moins** d'une UVC.
 */
export const SEUIL_ALIGNEMENT_UVC = '1';
//# sourceMappingURL=movement.js.map